import { api } from "./http-client";
import type { CreditTransaction } from "@pracownik/shared/types";

export const creditsApi = {
  getBalance: () => api.get<{ balance: number }>("/api/credits/balance").then((d) => d.balance),

  getTransactions: () =>
    api
      .get<{ transactions: CreditTransaction[] }>("/api/credits/transactions")
      .then((d) => d.transactions),
};
